/*-
 * #%L
 * Aires Éducatives
 * %%
 * Copyright (C) 2020 - 2023 OFB
 * %%
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 * #L%
 */
import { createI18n } from "vue-i18n"

/**
 * Charge dynamiquement tous les fichiers JSON de traduction depuis le dossier ./locales/
 * Utilise import.meta.glob() qui est l'équivalent Vite de require.context()
 */
function loadLocaleMessages() {
  const messages: Record<string, any> = {}

  // Chargement dynamique des fichiers de locale avec Vite
  // { eager: true } charge les modules immédiatement au lieu d'utiliser des imports dynamiques
  const modules = import.meta.glob("./locales/*.json", {
    eager: true,
    import: "default",
  }) as Record<string, any>

  // Parcours des modules chargés pour extraire le nom de la locale depuis le chemin
  for (const path in modules) {
    // Extraction du nom de locale depuis le chemin (ex: ./locales/fr.json -> fr)
    const matched = path.match(/\.\/locales\/([A-Za-z0-9-_]+)\.json$/i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = modules[path]
      console.log(`Locale chargée: ${locale} avec ${Object.keys(modules[path]).length} clés`)
    }
  }

  return messages
}

// Chargement des messages de traduction
const messages = loadLocaleMessages()

export default createI18n({
  legacy: false, // Utilise la nouvelle API de composition de Vue I18n
  globalInjection: true, // Permet d'utiliser $t, $te, etc. dans l'Options API
  locale: "fr", // Locale par défaut
  fallbackLocale: "fr", // Locale de fallback
  messages: messages,
  // Fonction de gestion d'erreur personnalisée
  missingHandler: (locale: string, key: string, vm?: any) => {
    console.warn("⚠️ [i18n] Clé de traduction manquante:", {
      locale,
      key,
      component: vm?.$options.name || vm?.__name || "Composant anonyme",
      timestamp: new Date().toISOString(),
    })
  },
  // Logs plus détaillés pour le débogage
  silentTranslationWarn: false,
  silentFallbackWarn: false,
})
